<template>
	<v-sheet dark  fill-height>
		<v-container fill-height>
			<v-row align="center" justify="center">
				<v-col lg="4" xl="3">
					<v-card class="card-center" fill-height color="black" dark outlined elevation="8"
						style="min-height:40vh">
						<v-card-text class="pos-r">
                            <div class="ripple accent-color circle pos-a" v-show="!error"></div>
							<BrandLogoLoader dark :width="4" :gutter="8" show-loading color="accent" />
						</v-card-text>
						<v-spacer />
						<v-card-text class="py-0">
							<h2>Parked&trade; Management</h2>
							<h4 class="mt-1 opacity">Make Yourself Worth!</h4>
						</v-card-text>
						<v-card-text class="shrink pt-0" v-if="error">
							<h2>{{error}}</h2>
							<v-btn large color="primary" class="mt-5" to="/">
                                Dashboard <v-icon right>$vuetify.icons.dashboard</v-icon>
                            </v-btn>
						</v-card-text>
						<v-card-text class="shrink pt-0" v-else>
							<CountDownTimer :time="3000" color="accent" :interval="100" height="52" rounded />
							<h5 class="mt-2">Loading your Dashboard</h5>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-sheet>
</template>

<script>
	import {
		mapGetters
	} from "vuex";

	import CountDownTimer from "@/components/CountDownTimer.vue";

	export default {
		name: "Callback",

		components: {
			CountDownTimer,
		},

		computed: {
			...mapGetters("auth", ["user", "authenticated", "authorized"])
		},

		data: () => ({
			error: null
		}),

		methods: {
			transferToPage() {
				const last_route =
					localStorage.getItem("route_to") &&
					JSON.parse(localStorage.getItem("route_to"));
				// console.log("Callback.transferToPage.last_route:", last_route);

				let params = (last_route && last_route.params) || {};
				let query = (last_route && last_route.query) || {};
				let path = (last_route && last_route.path) || "/dashboard";
				let routingObject = {
					path: path,
					params: params,
					query: query
				};
				this.$router.replace(routingObject);
			}
		},

		async created() {
			try {
				// dispatch auth:
				await this.$store.dispatch("auth/handleRedirectCallback");
				this.transferToPage();
			} catch (error) {
				console.log("Callback.created.auth/handleRedirectCallback.error", error);
				this.error = error.errorDescription;
			}
		}
	};
</script>

<style lang="css" scoped>
    .v-btn.primary{
        min-width: 250px;
    }
</style>